/** @format */
import React, { FC, useEffect, useState } from 'react'
import {
  Dialog,
  Icon,
  Select,
  Table,
  TableColumn,
  Option,
  Input,
  Message,
  _$
} from '@king-design/react'
// import { Dialog } from 'kpc-react'
import styled from 'styled-components'
import variable from 'src/static/styles/var'

interface TagSelectDialogProps {
  className?: string
  visible: boolean
  eventData: any
  tagList: any
  onOk: (data: any) => void
  onClose: () => void
}
const TagSelectDialog: FC<TagSelectDialogProps> = ({
  className,
  visible,
  eventData,
  tagList,
  onOk,
  onClose
}) => {
  const [tableData, setTableData] = useState<any>([])

  const onTableChange = (value, index) => {
    setTableData(prev => {
      return prev.map((item, i) => (i === index ? { ...item, ...value } : item))
    })
  }

  useEffect(() => {
    setTableData(visible ? eventData?.eventTags : [])
  }, [visible])

  const addTag = () => {
    setTableData(pre => [...pre, { tagName: '', tagValue: '' }])
  }

  return (
    <Dialog
      title={`${_$('维度设置')}（${eventData?.eventNameDesc}）`}
      value={visible}
      width={870}
      ok={() => {
        const valid = tableData?.every(item => {
          if (item.tagName && item.tagValue) {
            return true
          } else {
            Message.error(_$('请输入维度'))
            return false
          }
        })
        valid && onOk(tableData)
      }}
      onChangeValue={show => {
        if (!show) {
          onClose()
        }
      }}
    >
      <div className={className}>
        <Table
          data={tableData}
          checkType="none"
          animation={false}
          rowCheckable={false}
          type="grid"
          rowKey={({ tagName }) => tagName}
        >
          <TableColumn
            title={_$('维度名')}
            key="tagName"
            width={200}
            slotTemplate={([data, index]) => {
              return (
                <Select
                  value={data.tagName}
                  width={180}
                  onChangeValue={value => {
                    onTableChange({ tagName: value, tagValue: '' }, index)
                  }}
                >
                  {tagList?.map(({ tagName }) => (
                    <Option
                      value={tagName}
                      key={tagName}
                      disabled={!!tableData.find(item => item.tagName === tagName)}
                    >
                      {tagName}
                    </Option>
                  ))}
                </Select>
              )
            }}
          />
          <TableColumn
            title={_$('维度值')}
            key="tagValue"
            width={533}
            slotTemplate={([data, index]) => {
              return (
                <Input
                  value={data.tagValue}
                  placeholder={_$('请输入维度值，默认全部生效，多个值请使用英文,分割')}
                  width={513}
                  onChangeValue={value => {
                    onTableChange({ tagValue: value }, index)
                  }}
                />
              )
            }}
          />
          <TableColumn
            title={_$('操作')}
            key="active"
            width={80}
            slotTemplate={([data, index]) => {
              return (
                <a
                  onClick={() => {
                    setTableData(prev => {
                      return prev.filter((item, i) => i !== index)
                    })
                  }}
                >
                  {_$('删除')}
                </a>
              )
            }}
          />
        </Table>

        {tableData?.length < tagList?.length ? (
          <p className="add">
            <a onClick={() => addTag()}>
              <Icon className="ion-plus-round"></Icon>
              {_$('添加维度')}
            </a>
          </p>
        ) : null}
      </div>
    </Dialog>
  )
}

export default styled(TagSelectDialog)`
  .add {
    margin-top: 8px;
    a {
      line-height: 12px;
      font-size: 12px;
      .k-icon {
        font-size: 14px;
        margin-right: 4px;
        color: ${variable.primaryColor};
      }
    }
  }
`
